import { render, staticRenderFns } from "./shipmentFlowView copy.vue?vue&type=template&id=02d94480&scoped=true&"
import script from "./shipmentFlowView copy.vue?vue&type=script&lang=js&"
export * from "./shipmentFlowView copy.vue?vue&type=script&lang=js&"
import style0 from "./shipmentFlowView copy.vue?vue&type=style&index=0&id=02d94480&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d94480",
  null
  
)

export default component.exports